import React, { useEffect, useState } from 'react'
import OTPInput from 'react-otp-input'
import Handler from '../../../Helpers/Handler'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { contentLoadingChange } from '../../../Reducer/componentSlice'
import { useAuth } from '../../../Contexts/AuthenticateProvider'

const EmailStage = ({ customerDetails, onVerified }) => {

    const dispatch = useDispatch()
    const { hasPermission } = useAuth()
    const canSubmit = hasPermission("customer.email.manage")

    const [emailData, setEmailData] = useState({
        email: "",
        otp: ""
    })

    const [otpview, setOtpview] = useState(false)
    const [loading, setLoading] = useState(false)

    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    }

    const sendOtp = async () => {

        if (!canSubmit) {
            return toast.error("You don't have permission to manage this customer's email")
        }

        if (!validateEmail(emailData?.email)) {
            return toast.error("Invalid Email Address")
        }

        try {

            dispatch(contentLoadingChange(true))
            setLoading(true)

            const response = await Handler({
                method: "post",
                url: `/staff/customer/${customerDetails?.customerId}/email/otp`,
                data: {
                    email: emailData?.email
                }
            })

            if (response?.success) {
                toast.success(response?.data?.message || "OTP Sent Successfully")
                setOtpview(true)
            } else {
                toast.error(response?.data?.message || "Failed to send OTP")
            }

        } catch (error) {
            toast.error("Something went wrong")
        } finally {
            dispatch(contentLoadingChange(false))
            setLoading(false)
        }
    }

    const verifyOtp = async () => {

        if (!canSubmit) {
            return toast.error("You don't have permission to manage this customer's email")
        }

        if (!validateEmail(emailData?.email)) {
            return toast.error("Invalid Email Address")
        }

        if (!emailData?.otp || emailData?.otp?.length !== 5) {
            return toast.error("Invalid OTP")
        }

        try {

            dispatch(contentLoadingChange(true))
            setLoading(true)

            const response = await Handler({ method: "patch", url: `/staff/customer/${customerDetails?.customerId}/email/verify`, data: { email: emailData?.email, otp: emailData?.otp } })
            if (response?.success) {

                toast.success(response?.data?.message || "OTP Verified Successfully")

                setTimeout(() => {
                    setLoading(false)
                    onVerified?.()
                }, 1500)

            } else {
                setLoading(false)
                toast.error(response?.data?.message || "OTP Verification Failed")
            }

        } catch (error) {
            toast.error("Something went wrong")
            setLoading(false)
        } finally {
            dispatch(contentLoadingChange(false))
        }
    }

    useEffect(() => {
        setEmailData({
            email: customerDetails?.email?.emailId || "",
            otp: ""
        })

        setOtpview(false)
    }, [customerDetails])

    return (
        <>
            {!canSubmit ? (
                <div className="alert alert-warning small mb-3">
                    You don't have permission to manage this customer's email verification.
                </div>
            ) : null}
            <div className="mb-3">
                <label htmlFor="email" className="form-label fw-semibold">
                    Email Address
                </label>

                <input
                    type="email"
                    className="form-control"
                    disabled={otpview || loading || !canSubmit}
                    id="email"
                    value={emailData?.email}
                    placeholder="Enter Email Address"
                    onChange={(e) =>
                        setEmailData((prev) => ({
                            ...prev,
                            email: e?.target?.value
                        }))
                    }
                />

                <small className="text-muted">
                    OTP verification required
                </small>
            </div>

            {
                otpview && (
                    <>
                        <div className="mb-4">

                            <label className="form-label fw-semibold">
                                Enter OTP
                            </label>

                            <div className="d-flex justify-content-center">
                                <OTPInput
                                    value={emailData?.otp}
                                    onChange={(e) =>
                                        setEmailData((prev) => ({
                                            ...prev,
                                            otp: e
                                        }))
                                    }
                                    numInputs={5}
                                    shouldAutoFocus
                                    containerStyle={{ width: '100%' }}
                                    renderSeparator={<span className="mx-1"></span>}
                                    renderInput={(props) => (
                                        <input
                                            {...props}
                                            disabled={loading}
                                            className="form-control text-center mx-1"
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                fontSize: "18px",
                                                fontWeight: "600",
                                                borderRadius: "12px",
                                                flex: 1
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-between gap-3 mb-3">
                            <button className="btn btn-link p-0 text-decoration-none" disabled={loading} onClick={() => { setOtpview(false); setEmailData((prev) => ({ ...prev, otp: "" })) }}>
                                Change Email
                            </button>
                            <button className="btn btn-link p-0 text-decoration-none" disabled={loading} onClick={sendOtp}>Resend OTP</button>
                        </div>
                    </>
                )
            }

            <div className='text-center my-2'>

                {
                    otpview ? (
                        <button
                            className='btn btn-primary w-100 rounded-3'
                            disabled={loading || !canSubmit || emailData?.otp?.length !== 5}
                            onClick={verifyOtp}
                        >
                            {loading ? "Verifying..." : "Verify OTP"}
                        </button>
                    ) : (
                        <button
                            className='btn btn-primary w-100 rounded-3'
                            disabled={loading || !canSubmit}
                            onClick={sendOtp}
                        >
                            {loading ? "Sending..." : "Send OTP"}
                        </button>
                    )
                }

            </div>
        </>
    )
}

export default EmailStage